<template>
  <div id="report" class="p-4">
    <div class="card w-100" v-if="Object.keys(getReport).length">
      <div class="card-header py-3">
        <div class="row justify-content-between">
          <div class="col-6">
            <div class="pt-2 font-bold text-uppercase">
              {{ getReport.platform.station.name }} {{ getReport.platform.name }}
              <span class="font-default pl-3">{{ getReport.created_at }}</span>
            </div>
            <div v-if="getReport.platform_description" class="text-muted my-3">Platform Description: <span class="font-default pl-3">{{ getReport.platform_description }}</span></div>
            <div v-if="getReport.traction_types" class="text-muted my-3">Traction types using this platform: <span class="font-default pl-3" style="white-space: pre;">{{ getReport.traction_types }}</span></div>
          </div>
          <div class="col-6">
            <a :href="export_url" target="_blank" @click.prevent="exportPdf">
              <b-button type="submit" size="sm" variant="outline-dark" class="btn-image float-right">
                <img src="../assets/img/export-icon.png"> <span>EXPORT PDF</span>
              </b-button>
            </a>
          </div>
        </div>
      </div>
      <div class="card-body p-4">
        <div v-for="(result_answer, index) of getReport.result_answers" :key="index" class="mb-3">
          <div class="mb-2">
            <b-badge pill variant="index">{{ index+1 }}</b-badge>
            <span class="text-muted font-light pl-2">{{ result_answer.question.section.name }}</span>
          </div>
          <div class="text-dark my-3">{{ result_answer.question.text }}</div>
          <div :class="['badge', 'badge-' + result_answer.answer.color, 'mb-2']">{{ result_answer.answer.color }}</div>
          <div v-if="result_answer.notes ">
            <div class="text-muted my-3">Notes</div>
            <div class="text-dark">{{ result_answer.notes }}</div>
          </div>
          <div v-if="result_answer.corrective_action">
            <div class="text-muted mt-3 mb-2">Corrective Action</div>
            <div class="text-dark">{{ result_answer.corrective_action }}</div>
          </div>
          <div v-if="result_answer.issues_identified">
            <div class="text-muted mt-3 mb-2">Risks/issues identified</div>
            <div class="text-dark">{{ result_answer.issues_identified }}</div>
          </div>
          <div class="text-muted mt-3 mb-2" v-if="result_answer.attendees">Other Attendees Present</div>
          <div class="text-dark mt-3" v-if="result_answer.attendees">{{ result_answer.attendees }}</div>
          <div class="text-muted mt-3 mb-2 pb-3 border-bottom">
            <span
                v-if="result_answer.responsible_user !== null">{{ result_answer.responsible_user.name }} {{ result_answer.responsible_user.surname }}</span><span
              v-if="result_answer.date !== null"> / {{ result_answer.date }}</span>
          </div>
          <div v-if="result_answer.images" class="text-muted mt-3 mb-2 pb-3">
            <div v-for="(image_link, index) of result_answer.images" :key="index" class="img-container">
              <div>{{ result_answer.image_names[index] }}</div>
              <img :src="image_link" class="img-crop" width="200">
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>


        <div class="text-muted my-3">Dispatch Matrix Position</div>
        <div class="text-dark" style="white-space: pre;">{{ getReport.matrix_position }}</div>

        <div class="text-muted my-3">Other Attendees Present</div>
        <div class="text-dark" style="white-space: pre;">{{ getReport.attendees }}</div>

        <div class="text-muted my-3">Notes</div>
        <div class="text-dark" style="white-space: pre;">{{ getReport.notes }}</div>

      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'Report',
    props: ['id'],
    data() {
      return {
        export_url: process.env.VUE_APP_API_ENDPOINT + 'reports/' + this.id + '/export'
      }
    },
    computed: {
      ...mapGetters([
        'getReport',
      ])
    },
    mounted() {
      this.queryReport(this.id)
    },
    methods: {
      ...mapActions([
        'queryReport',
      ]),
      exportPdf() {
        window.axios.get(this.export_url, {responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], {type: 'application/pdf'})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'export'
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)
      }
    }
  }
</script>

<style scoped>
  .img-container {
    float: left;
    border: 1px solid #444;
    padding: 5px;
    margin: 10px;
  }

</style>